'use strict';
DoohApps
.directive('validJson', function () {
    // requires an isloated model
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, ele, attrs, ctrl) {
            function validate(value) {
                if (value == 'N/A' || value == 'n/a' || value == '') return true;
                else {
                    try {
                        JSON.parse(value);
                        return true;
                    }
                    catch (e) {
                        return false;
                    }
                }
            }
            // add a parser that will process each time the value is
            // parsed into the model when the user updates it.
            ctrl.$parsers.unshift(function (value) {
                var valid = validate(value);
                                 
                ctrl.$setValidity('validJson', valid);
                
                return value;//valid ? value : undefined;
            });
            ctrl.$formatters.unshift(function (value) {
                if (value) {
                    var valid = validate(value);
                    ctrl.$setValidity('validJson', valid);
                    ctrl.$setDirty();
                }
                else ctrl.$setValidity('validJson', true);
                
                return value;
            });

        }
    }
});